<div class="pick__hour-container">
  <label for="pick-hour">{{label()}}</label>
  <button type="button" class="pick__hour-input" (click)="openPickHourModal()" tabindex="0">
    <input
    type="text"
    readonly="true"
    [placeholder]="placeholder()"
    [formControl]="control"
    [value]="control.value"
    >
    <img src="assets/icons/ico_chevron_down.svg" alt="">
  </button>
</div>